
import { Button } from "@/components/ui/button";
import { Users, BookText, Settings as SettingsIcon, Sparkles, UserCircle, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export function AdminNavigation() {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleNavigation = (path: string) => {
    // First scroll to top, then navigate
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Immediate navigation to prevent partial scrolling
    navigate(path);
  };

  const handleSignOut = async () => {
    try {
      await supabase.auth.signOut();
      sessionStorage.removeItem('adminViewEnabled');
      toast({
        title: "Signed Out",
        description: "You have been successfully signed out",
      });
      navigate("/");
    } catch (error) {
      console.error("Error signing out:", error);
      toast({
        title: "Error",
        description: "Failed to sign out",
        variant: "destructive",
      });
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-[#0A2540] border-t border-[#143a5c] p-2 md:p-4">
      <div className="flex justify-around max-w-2xl mx-auto">
        <Button
          variant="ghost"
          className="flex flex-col items-center gap-1 text-gray-200 hover:text-white hover:bg-[#143a5c] px-2"
          onClick={() => handleNavigation("/admin/users")}
        >
          <UserCircle className="w-5 h-5" />
          <span className="text-[10px] md:text-xs text-white">Users</span>
        </Button>

        <Button
          variant="ghost"
          className="flex flex-col items-center gap-1 text-gray-200 hover:text-white hover:bg-[#143a5c] px-2"
          onClick={() => handleNavigation("/admin/congregations")}
        >
          <Users className="w-5 h-5" />
          <span className="text-[10px] md:text-xs text-white">Congregations</span>
        </Button>
        
        <Button
          variant="ghost"
          className="flex flex-col items-center gap-1 text-gray-200 hover:text-white hover:bg-[#143a5c] px-2"
          onClick={() => handleNavigation("/admin/sermons")}
        >
          <BookText className="w-5 h-5" />
          <span className="text-[10px] md:text-xs text-white">Sermons</span>
        </Button>
        
        <Button
          variant="ghost"
          className="flex flex-col items-center gap-1 text-gray-200 hover:text-white hover:bg-[#143a5c] px-2"
          onClick={() => handleNavigation("/admin/ai-settings")}
        >
          <Sparkles className="w-5 h-5" />
          <span className="text-[10px] md:text-xs text-white">AI</span>
        </Button>
        
        <Button
          variant="ghost"
          className="flex flex-col items-center gap-1 text-gray-200 hover:text-white hover:bg-[#143a5c] px-2"
          onClick={() => handleNavigation("/settings")}
        >
          <SettingsIcon className="w-5 h-5" />
          <span className="text-[10px] md:text-xs text-white">Settings</span>
        </Button>

        <Button
          variant="ghost"
          className="flex flex-col items-center gap-1 text-gray-200 hover:text-white hover:bg-[#143a5c] px-2"
          onClick={handleSignOut}
        >
          <LogOut className="w-5 h-5" />
          <span className="text-[10px] md:text-xs text-white">Sign Out</span>
        </Button>
      </div>
    </nav>
  );
}
